import type { HTMLAttributes, ReactNode } from 'react';
import { Flap } from '../Flap/Flap';
import './board.css';

export interface BoardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'done' | 'verdict' | 'mini';
}

/** The navy departure-board card: S5's payoff, S9's verdict, S12's claim reference, S15's flight. */
export function Board({ variant, className, ...rest }: BoardProps) {
  return (
    <div
      className={['board', variant && `board--${variant}`, className].filter(Boolean).join(' ')}
      {...rest}
    />
  );
}

export interface ClaimRefBoardProps {
  /** e.g. "Claim started", "Not signed yet" (uppercased by CSS). */
  eyebrow: ReactNode;
  /** The claim reference, e.g. DB-2Q7F4K. */
  reference: string;
  /** The line under the reference. */
  sub?: ReactNode;
  /** Play the split-flap reveal (first pass only, never on a return visit). */
  reveal?: boolean;
  children?: ReactNode;
}

/** The claim reference on the board (S12, S15's ending). */
export function ClaimRefBoard({ eyebrow, reference, sub, reveal = false, children }: ClaimRefBoardProps) {
  return (
    <Board variant="done">
      <span className="done__eyebrow">{eyebrow}</span>
      <Flap text={reference} tone="gold" animate={reveal} />
      {sub && <p className="done__sub">{sub}</p>}
      {children}
    </Board>
  );
}
